import { sanitizeInternalReturnTo } from "./authReturn";

// A deal card in a win-back or roundup email links a free account to checkout
// as /setup?plan=...&deal=/<retailer>/product/<upc>?storeId=<id> (the product
// page itself is members-only). The paywall remembers the deal and the
// success page opens it once the plan is active.

const KEY = "dh_email_deal";
const MAX_AGE_MS = 24 * 60 * 60 * 1000;
const DEAL_PATH = /^\/[a-z_]+\/product\/[^/?#]+\?storeId=[\w-]+$/;

export function emailDealPath(value?: string | null): string | undefined {
  const path = sanitizeInternalReturnTo(value);
  return path && DEAL_PATH.test(path) ? path : undefined;
}

export function rememberEmailDeal(search: string): void {
  const path = emailDealPath(new URLSearchParams(search).get("deal"));
  if (!path) return;
  try {
    localStorage.setItem(KEY, JSON.stringify({ path, at: Date.now() }));
  } catch {
    // Storage blocked: checkout still works, it just lands on the default page.
  }
}

export function takeEmailDeal(now = Date.now()): string | undefined {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return undefined;
    localStorage.removeItem(KEY);
    const saved = JSON.parse(raw) as { path?: string; at?: number };
    if (!saved.at || now - saved.at > MAX_AGE_MS) return undefined;
    return emailDealPath(saved.path);
  } catch {
    return undefined;
  }
}
